import { render, staticRenderFns } from "./QueuePopup.vue?vue&type=template&id=4bebc7e2&scoped=true&"
import script from "./QueuePopup.vue?vue&type=script&lang=js&"
export * from "./QueuePopup.vue?vue&type=script&lang=js&"
import style0 from "./QueuePopup.vue?vue&type=style&index=0&id=4bebc7e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bebc7e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bebc7e2')) {
      api.createRecord('4bebc7e2', component.options)
    } else {
      api.reload('4bebc7e2', component.options)
    }
    module.hot.accept("./QueuePopup.vue?vue&type=template&id=4bebc7e2&scoped=true&", function () {
      api.rerender('4bebc7e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/queuePopup/QueuePopup.vue"
export default component.exports